import React from 'react'
import { ContactForm } from '../components/contact/ContactForm'
import { AboutUs } from '../components/about/AboutUs'

export const LANGUAGES: AppLocale[] = ['de', 'en', 'es', 'nl', 'fr', 'it']
export const CURRENCIES: AppCurrency[] = ['EUR', 'USD', 'GBP']

export const SEARCH_RESULTS_TYPE_ORDER = [
  'city',
  'category',
  'product',
  'region',
  'state',
  'country',
]

export const MAP_TYPES_TO_TERMS = {
  country: 'Land',
  city: 'Stadt',
  categories: 'Kategorie',
  product: 'Aktivität',
}

export const LOCAL_SLUGS = [
  {
    id: 'contact',
    de: 'kontakt',
    en: 'contact',
    es: 'contacto',
    nl: 'contact',
    fr: 'contact',
    it: 'contatto',
    component: () => <ContactForm />,
  },
  {
    id: 'about',
    de: 'ueber-uns',
    en: 'about-us',
    es: 'sobre-nosotros',
    nl: 'over-ons',
    fr: 'a-propos',
    it: 'chi-siamo',
    component: () => <AboutUs />,
  },
  {
    id: 'faq',
    de: 'faq',
    en: 'faq',
    es: 'faq',
    nl: 'faq',
    fr: 'faq',
    it: 'faq',
    component: () => <div>faq</div>,
  },
  {
    id: 'sitemap',
    de: 'Sitemap.xml',
    en: 'Sitemap.xml',
    es: 'Sitemap.xml',
    nl: 'Sitemap.xml',
    fr: 'Sitemap.xml',
    it: 'Sitemap.xml',
  },
]

export const SIGHT2SIGHT_FALLBACK_ALT =
  'Sight2Sight Image - Entdecke die Welt mit SIGHT2SIGHT'
export const SIGHT2SIGHT_FALLBACK_TITLE =
  'Sight2Sight Image - Entdecke die Welt mit SIGHT2SIGHT'

export const GLOBAL_FALLBACK_IMAGE: Image = {
  image: {
    asset: {
      _ref: 'image-ab74a41115104e89d32f3dc3caf6345063c21d0e-2000x1332-jpg',
      _type: 'reference',
    },
    crop: {
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
    },
    hotspot: {
      x: 0.5,
      y: 0.5,
      height: 1,
      width: 1,
    },
    _type: 'image',
  },
  _type: 'custom_image',
}

export const AFFILIATE_PARTNERS = [
  {
    name: 'Tiqets',
    logo: '/assets/affiliate_partners/tiqets.png',
    height: 80,
    width: 80,
  },
  {
    name: 'Civitatis',
    logo: '/assets/affiliate_partners/civitatis.png',
    height: 80,
    width: 80,
  },
  {
    name: 'Get Your Guide',
    logo: '/assets/affiliate_partners/gyg.png',
    height: 70,
    width: 70,
  },
  {
    name: 'Musement',
    logo: '/assets/affiliate_partners/musement.png',
    height: 80,
    width: 80,
  },
  {
    name: 'Viator',
    logo: '/assets/affiliate_partners/viator.png',
    height: 80,
    width: 80,
  },
]

export const PAYMENT_PARTNERS = [
  {
    name: 'Apple',
    logo: '/assets/payment_partners/apple.png',
  },
  {
    name: 'Klarna',
    logo: '/assets/payment_partners/klarna.png',
  },
  {
    name: 'Mastercard',
    logo: '/assets/payment_partners/mastercard.png',
  },
  {
    name: 'PayPal',
    logo: '/assets/payment_partners/paypal.png',
  },
  {
    name: 'Visa',
    logo: '/assets/payment_partners/visa.png',
  },
  {
    name: 'Sepa',
    logo: '/assets/payment_partners/sepa.png',
  },
]

export const LEGAL = [
  {
    title: 'legal',
    content: [{ id: 'imprint' }, { id: 'terms' }, { id: 'privacy' }],
  },
  {
    title: 'service',
    content: [{ id: 'cookie-settings' }, { id: 'contact' }, { id: 'about' }, { id: 'sitemap' }],
  },
  {
    title: 'contact-title',
    content: [
      { id: 'email' },
      { id: 'firma' },
      { id: 'website-url', href: '' },
    ],
  },
]

export const CATEGORY_PRIORITY_ORDER = [
  'Schifffahrten',
  'Hafenrundfahrten',
  'Stadtrundfahrten',
  'Katamaran Touren',
  'City Cards',
  'Ballonfahrten',
  'Schnorcheltouren',
  'Eintrittskarten',
  'Schlossführungen',
  'Kanalfahrten',
  'Stadtführungen',
  'Food Touren',
  'Tagesausflüge',
  'Private Touren',
  'Schnorcheltouren',
  'Fahrrad Touren',
  'Kombi Touren',
  'Transfers',
  'Schulausflüge',
]

export const HEADER_CATEGORIES = [
  {
    _id: '5434db8d-05ec-407d-8e41-aed00c63358e',
    de: 'Bootstouren',
    en: 'Boat tours',
    es: 'Paseos en barco',
    fr: 'Sorties en bateau',
    it: 'Tour in barca',
    nl: 'Boottochten',
  },
  {
    _id: '6422957b-ce1e-4352-b4ec-b2ca8f8f3804',
    de: 'Stadtrundfahrten',
    en: 'City tours',
    es: 'Excursiones en autobús',
    fr: 'Tours de ville',
    it: 'Tour della città in autobus',
    nl: 'Stadsrondleidingen',
  },
  {
    _id: 'ea2d3660-0b13-48d3-9212-47c0b513a95e',
    de: 'City Cards',
    en: 'City Cards',
    es: 'City Cards',
    fr: 'City Cards',
    it: 'City Cards',
    nl: 'City Cards',
  },
  {
    _id: '725947d9-5a6f-4c72-861d-8367f141b473',
    de: 'Stadtführungen',
    en: 'Walking tours',
    es: 'Tour guiado',
    fr: 'Visites guidées',
    it: 'Visite guidate',
    nl: 'Stadswandelingen',
  },
  {
    _id: 'fd6480ea-0821-48bd-9ac6-1c892a75c10b',
    de: 'Schnorcheltouren',
    en: 'Snorkeling tours',
    es: 'Excursiones de snorkel',
    fr: 'Excursions de plongée en apnée',
    it: 'Tour di snorkeling',
    nl: 'Snorkeltours',
  },
  {
    _id: 'b1e4d570-7e1b-4491-b5d6-1883de38da64',
    de: 'Eintrittskarten',
    en: 'Tickets',
    es: 'Entradas',
    fr: "Billets d'entrée",
    it: 'Biglietti',
    nl: 'Tickets',
  },
  {
    _id: '137d2388-55cd-44b4-962e-f136b3716c89',
    de: 'Food Touren',
    en: 'Food tours',
    es: 'Tours gastronómicas',
    fr: 'Visites gastronomiques',
    it: 'Tour gastronomici',
    nl: 'Voedseltours',
  },
  {
    _id: '9813ff73-6e61-4439-ac64-07eddfb67287',
    de: 'Fahrrad Touren',
    en: 'Bike tours',
    es: 'Recorridos en bicicleta',
    fr: 'Circuits à vélo',
    it: 'Tour in bicicletta',
    nl: 'Fietstochten',
  },
  {
    _id: 'cc1da249-d1ed-4ac7-a8e0-8ea79215f925',
    de: 'Tagesausflüge',
    en: 'Day trips',
    es: 'Excursiones de un día',
    fr: "Excursions d'une journée",
    it: 'Gite di un giorno',
    nl: 'Dagtochten',
  },
  {
    _id: 'fb58cd74-3be4-483e-9068-358f1027f6f9',
    de: 'Private Touren',
    en: 'Private tours',
    es: 'Tours privados',
    fr: 'Tours privés',
    it: 'Tour privati',
    nl: 'Privérondleidingen',
  },
  {
    _id: '53064a35-9911-44a1-81c7-5aad99df7473',
    de: 'Kombi Touren',
    en: 'Combined tours',
    es: 'Tours combinados',
    fr: 'Tours combinés',
    it: 'Tour combinati',
    nl: 'Combinatie Tours',
  },
  {
    _id: '1d5df8f0-d640-4a0e-afdf-eaf343b62c35',
    de: 'Schlossführungen',
    en: 'Castle tours',
    es: 'Visitas a castillos',
    fr: 'Visites de châteaux',
    it: 'Tour del castello',
    nl: 'Kastelentochten',
  },
  {
    _id: '735b9f2c-afcc-42ba-9b0f-ae205d12e001',
    de: 'Ballonfahrten',
    en: 'Balloon rides',
    es: 'Paseos en globo',
    fr: 'Vols en montgolfière',
    it: 'Giri in mongolfiera',
    nl: 'Ballonvaarten',
  },
  {
    _id: '4dc6d738-be70-4357-b429-f3b9381e5772',
    de: 'Katamaran Touren',
    en: 'Catamaran tours',
    es: 'Excursiones en catamarán',
    fr: 'Excursions en catamaran',
    it: 'Tour in catamarano',
    nl: 'Catamarantours',
  },
  {
    _id: '9dfe06ac-bdab-4b4a-b9e3-0481c6c7e5dd',
    de: 'Tauchkurse',
    en: 'Diving courses',
    es: 'Cursos de buceo',
    fr: 'Cours de plongée',
    it: 'Corsi di immersione',
    nl: 'Duikcursussen',
  },
  {
    _id: '327e08e8-5d39-4cbc-8b24-a762ee37ef2c',
    de: 'Transfers',
    en: 'Transfers',
    es: 'Traslados',
    fr: 'Transferts',
    it: 'Trasferimento',
    nl: 'Transfer',
  },
  {
    _id: '4dfba8fc-5590-4dcf-8063-3b57399857af',
    de: 'Kanalfahrten',
    en: 'Canal cruises',
    es: 'Cruceros por los canales',
    fr: 'Croisières sur les canaux',
    it: 'Crociere sui canali',
    nl: 'Rondvaarten',
  },
  {
    _id: '07b7b971-64ea-4b4f-852a-5f219fc6d0fd',
    de: 'Hafenrundfahrten',
    en: 'Harbour cruises',
    es: 'Cruceros portuarios',
    fr: 'Croisières dans le port',
    it: 'Crociere in porto',
    nl: 'Havenrondvaarten',
  },
  {
    _id: 'be354ac7-6da9-4e29-9fdb-b86501e2ef91',
    de: 'Schulausflüge',
    en: 'School trips',
    es: 'Excursiones escolares',
    fr: 'Voyages scolaires',
    it: 'Gite scolastiche',
    nl: 'Schoolreisjes',
  },
  {
    _id: 'c7b0bcc2-59e2-4b52-97cd-dbc6e9aad918',
    de: 'Free Walking Touren',
    en: 'Free walking tours',
    es: 'Paseos gratuitos',
    fr: 'Visites guidées gratuites',
    it: 'Tour a piedi gratuiti',
    nl: 'Gratis Stadswandeling',
  },
  {
    _id: '92de99f3-1bb0-46ba-a460-5e8398694dea',
    de: 'Lichterfahrten',
    en: 'Light tours',
    es: 'Recorridos luminosos',
    fr: 'Tour des illuminations',
    it: 'Tour di illuminata',
    nl: 'Lichtjestour',
  },
  {
    _id: 'ba293199-aa38-4f70-98a3-a34c087ed912',
    de: 'Aktivitäten für Pärchen',
    en: 'Activities for couples',
    es: 'Actividades para parejas',
    fr: 'Activités pour les couples',
    it: 'Attività per le coppie',
    nl: 'Activiteiten voor koppels',
  },
  {
    _id: '1e93eeda-9692-4c6b-99ac-72b424eb3843',
    de: 'Ausflüge mit Kindern',
    en: 'Excursions with children',
    es: 'Excursiones con niños',
    fr: 'Excursions avec des enfants',
    it: 'Escursioni con i bambini',
    nl: 'Excursies met kinderen',
  },
  {
    _id: 'c7b8a94f-b6b7-4c17-bbd2-7709f7b473b6',
    de: 'Events',
    en: 'Events',
    es: 'Eventos',
    fr: 'Événements',
    it: 'Eventi',
    nl: 'Evenementen',
  },
  {
    _id: 'ef6cbefe-af56-4454-80a6-0138188ebdb6',
    de: 'Geheimtipps',
    en: 'Insider tips',
    es: 'Secretos',
    fr: "Conseils d'initiés",
    it: 'Suggerimenti utili',
    nl: 'Insidertips',
  },
]

export const ICONS_FOR_CATEGORIES = {
  'Alle Aktivitäten': 'fa-duotone fa-landmark #004a78',
  'Aktivitäten für Pärchen': 'fa-duotone fa-people-pants #a62182',
  'Ausflüge mit Kindern': 'fa-duotone fa-child-reaching #f777b8',
  'Sightseeing Touren': 'fa-duotone fa-landmark-magnifying-glass #bcae91',
  'Selbstgeführte Touren': 'fa-duotone fa-headphones-simple #fbba00',
  Geheimtipps: 'fa-duotone fa-key #575757',
  Stadtführungen: 'fa-duotone fa-people-group #f79a20',
  'Food Touren': 'fa-duotone fa-utensils #12db81',
  'Kulinarische Stadtführungen': 'fa-duotone fa-bowl-spoon #ffa366',
  'Eintrittskarten & Tickets': 'fa-duotone fa-ticket #ffc106',
  'Fahrrad Touren': 'fa-duotone fa-bicycle #3bb97a',
  'Private Touren': 'fa-duotone fa-user-lock #bcae91',
  Events: 'fa-duotone fa-calendar-star #f27474',
  Transfers: 'fa-duotone fa-van-shuttle #969698',
  Kanalfahrten: 'fa-duotone fa-bridge-water #8564ed',
  Hafenrundfahrten: 'fa-duotone fa-ship #26a5ef',
  Tagesausflüge: 'fa-duotone fa-route #01998a',
  Stadtrundfahrten: 'fa-duotone fa-bus #ff6666',
  Schifffahrten: 'fa-duotone fa-ferry #9ee0ff',
  Bootstouren: 'fa-duotone fa-anchor #0e6e9c',
  'City Cards': 'fa-duotone fa-memo-circle-info #5d3ebc',
  'Kombi-Touren': 'fa-duotone fa-user-plus #fd3a9d',
  Schulklassen: 'fa-duotone fa-user-graduate #b71f36',
  'Free Walking Touren': 'fa-duotone fa-shoe-prints #d6203c',
  Flussfahrten: 'fa-duotone fa-water #2544c2',
  Schnorcheltouren: 'fa-duotone fa-mask-snorkel #0055c4',
  'Hop-On Hop-Off': 'fa-duotone fa-shuffle #ff6666',
}

// Constants for city slugs
const CITY_SLUGS = {
  BREMEN: 'bremen',
  HAMBURG: 'hamburg',
  BERLIN: 'berlin',
}

// Map of city names in different languages
export const STATE_NAMES = {
  [CITY_SLUGS.BREMEN]: {
    de: 'hansestadt-bremen',
    en: 'hanseatic-city-of-bremen',
    es: 'ciudad-hanseática-de-bremen',
    nl: 'hanzestad-bremen',
    fr: 'ville-hanseatique-de-breme',
    it: 'citta-anseatica-di-brema',
  },
  [CITY_SLUGS.HAMBURG]: {
    de: 'hansestadt-hamburg',
    en: 'hanseatic-city-of-hamburg',
    es: 'ciudad-hanseática-de-hamburgo',
    nl: 'hanzestad-hamburg',
    fr: 'ville-hanseatique-de-hambourg',
    it: 'citta-anseatica-di-amburgo',
  },
  [CITY_SLUGS.BERLIN]: {
    de: 'hauptstadt-berlin',
    en: 'capital-berlin',
    es: 'capital-berlín',
    nl: 'hoofdstad-berlijn',
    fr: 'capitale-berlin',
    it: 'capitale-berlino',
  },
}

// Map of city destinations in different languages
export const CITY_DESTINATIONS = {
  [CITY_SLUGS.BREMEN]: {
    de: 'bremen',
    en: 'bremen',
    es: 'bremen',
    nl: 'bremen',
    fr: 'breme',
    it: 'brema',
  },
  [CITY_SLUGS.HAMBURG]: {
    de: 'hamburg',
    en: 'hamburg',
    es: 'hamburgo',
    nl: 'hamburg',
    fr: 'hambourg',
    it: 'amburgo',
  },
  [CITY_SLUGS.BERLIN]: {
    de: 'berlin',
    en: 'berlin',
    es: 'berlin',
    nl: 'berlijn',
    fr: 'berlin',
    it: 'berlino',
  },
}
